import React from "react";

import {
  getEventStatus,
  getTypeBadgeClass,
} from "../utils/convocationsAdmin.utils";

export function EventTypeBadge({ type }) {
  if (!type) {
    return (
      <span className="text-xs italic text-slate-400">
        Type non renseigné
      </span>
    );
  }

  return (
    <span
      className={`inline-flex max-w-full items-center rounded-full border px-2.5 py-1 text-[11px] font-semibold ${getTypeBadgeClass(
        type,
      )}`}
    >
      <span className="truncate">
        {type}
      </span>
    </span>
  );
}

export function EventStatusPill({ start }) {
  const status = getEventStatus(start);

  return (
    <span
      className={`inline-flex shrink-0 items-center rounded-full border px-2.5 py-1 text-[11px] font-semibold ${status.className}`}
    >
      {status.label}
    </span>
  );
}